import { DetailSection, ViewerContainer } from "./styled";
import { findTargetMenuName } from "../../common/function/shopping";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import { useMediaQuery } from "react-responsive";
import { BsClock } from "react-icons/bs";
import { FaUserPen } from "react-icons/fa6";
import { useRef } from "react";
import MediaViewer from "../../../../common/mediaViewer";

const Viewer = () => {
  const navigate = useNavigate();
  const contentRef = useRef();
  const { theme, menus, url } = useOutletContext();
  const [portfolio, setPortfolio] = useState();
  const { portNo } = useParams();
  const location = useLocation();
  const searchQuery = location?.state?.keyword || "";
  const pageQuery = location?.state?.page || 0;
  const moveToUrl = searchQuery
    ? `/shop/${url}/search?keyword=${searchQuery}`
    : `/shop/${url}/portfolio?page=${pageQuery}`;
  const [images, setImages] = useState([]);
  const [isDetail, setIsDetail] = useState(false);

  useEffect(() => {
    getPortfolio();
  }, []);

  useEffect(() => {
    const images = contentRef.current?.querySelectorAll("img");
    images?.forEach((img) => {
      img.style.cursor = "pointer";
      img.addEventListener("click", (e) => handleImageClick(img.src));
    });

    return () => {
      images?.forEach((img) => {
        img.removeEventListener("click", () => handleImageClick(img.src));
      });
    };
  }, [portfolio]);

  const handleImageClick = (src) => {
    setImages([src]);
    setIsDetail(true);
  };

  const getPortfolio = async () => {
    const url = "/api/portMgmtList";
    const body = {
      portNo,
      useYn: "Y",
      notitleYn: "Y",
      offset: 0,
      pageNumber: 0,
      pageSize: 12,
      paged: true,
    };

    try {
      const res = await axios.post(url, body);
      const data = res?.data?.content;
      if (data && data.length > 0) {
        setPortfolio(data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <ViewerContainer className={`theme-${theme}`}>
        <h3>
          <span>{findTargetMenuName(menus, 2)}</span>
        </h3>
        <DetailSection className={`theme-${theme}`}>
          <div className="info">
            <p>{portfolio?.title}</p>
            <div className="details">
              <span>
                <FaUserPen />
                {portfolio?.createMberId}
              </span>
              <span>
                <BsClock /> {portfolio?.updateDt || portfolio?.createDt}
              </span>
            </div>
            <button onClick={() => navigate(`/shop/${url}/portfolio`)}>전체 포트폴리오 보기</button>
          </div>
          <div className="contents" ref={contentRef}>
            <div dangerouslySetInnerHTML={{ __html: portfolio?.contents || "" }}></div>
          </div>
          <div className="buttons center">
            <button onClick={() => navigate(moveToUrl)}>목록</button>
          </div>
        </DetailSection>
      </ViewerContainer>
      {isDetail && <MediaViewer files={images} setIsOpen={setIsDetail} />}
    </>
  );
};

export default Viewer;
